import { render, staticRenderFns } from "./uploadComOne.vue?vue&type=template&id=4df3d082"
import script from "./uploadComOne.vue?vue&type=script&lang=js"
export * from "./uploadComOne.vue?vue&type=script&lang=js"
import style0 from "./uploadComOne.vue?vue&type=style&index=0&id=4df3d082&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports